import React, { useEffect } from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { TramoCreationContent } from './components/TramoCreationContent';
import { useLocation } from 'react-router-dom';

export default function TramoCreation() {
    const location = useLocation();
    const { isNew, allowedWrite } = location.state;

    return (
        <MainContent
            component={<TramoCreationContent />}
            titulo={`${allowedWrite ? ((isNew) ? 'Nuevo ' : 'Editar ') : ''} Tramo`}
            noBackground
            tableMaxWidth
        />
    );

};
